import { render, staticRenderFns } from "./Avances.vue?vue&type=template&id=8efbcae8&"
import script from "./Avances.vue?vue&type=script&lang=js&"
export * from "./Avances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports